import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "library-type";

export type library_type_list = {
    page?: number;
    limit?: number;
    sortBy?: string;
    sortType?: string;
    search?: string;
    category_library?: string;
    start_date?: string;
    end_date?: string;
    ready_to_borrow?: boolean;
}
export type create_library = {
    library_type_name: string;
    books: boolean;
    e_books: boolean;
    magazine: boolean;
    thesis: boolean;
    podcast: boolean;
    audio_books: boolean;
    video: boolean;
}
export class LibraryTypeApi extends BaseAPI {
    static list(params: library_type_list): Promise<AxiosResponse> {
        return this.api.get(`${path}/list`, { params: params })
    }
    static create(body: create_library): Promise<AxiosResponse> {
        return this.api.post(`${path}`, body)
    }
    static update(id_library_type: number, body: create_library): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_library_type}`, body)
    }
    static delete(id_library_type: number): Promise<AxiosResponse> {
        return this.api.delete(`${path}/${id_library_type}`)
    }
}